'use strict';

var ret = {};

ret.types = ['adwords', 'angel', 'bing', 'crunchbase', 'direct', 'facebook', 'googleOrganic', 'medium', 'techcrunch', 'twitter', 'other'];

ret.heardFrom = ['friend', 'restaurant', 'other'];

ret.heardFrom = ['friend', 'restaurant', 'other'];

// map query parameters for custom URLs to service
ret.serviceMap = {
  gclid: 'adwords',
  fbRef: 'facebook',
  twitterRef: 'twitter'
};

// map urls to services in case no query parameter match (protocol stripped)
ret.referrerMap = {
  'www.google.com/': 'googleOrganic',
  'www.facebook.com/': 'facebook',
  'www.twitter.com/': 'twitter',
  'www.bing.com/': 'bing'
};

module.exports = ret;